import { render } from "./App.vue?vue&type=template&id=44246e42&scoped=true&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=44246e42&lang=scss"
import "./App.vue?vue&type=style&index=1&id=44246e42&lang=scss&scoped=true"

import exportComponent from "D:\\Zeng\\Working\\云图\\2021年\\足协管理系统\\足协新版2\\FMIS-Page\\FMIS-Front-Page\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44246e42"]])

export default __exports__